export default {
  pages: {
    key: 'title',
    data: [
      {
        title: 'Home', url: '/', icon: 'HomeIcon', is_bookmarked: false
      },
      {
        title: 'Nuevo DTE', url: '/factura-electronica/emision/basica', icon: 'FileIcon', is_bookmarked: false
      },
      {
        title: 'Emitidos', url: '/factura-electronica/emitidos/todos', icon: 'ExternalLinkIcon', is_bookmarked: false
      },
      {
        title: 'Recibidos', url: '/factura-electronica/recibidos/todos', icon: 'InboxIcon', is_bookmarked: false
      },
      // {title: 'Page 2',       url: '/page2',                                    icon: 'FileIcon', is_bookmarked: false},
    ]
  }
};
